import { getLocalStorage } from './storage'

import { checkIfSelfAccountRelatedLink, getCurrentRoute, updateRouteParams } from './url'

import { ROUTE_PARAMS } from '../constants/routes'
import { SELECTED_SELF_ACCOUNT } from '../modules/reducers/app'

export function getInitialSelfAccount(selfAccounts, selfAccountFromPath) {
  const isAccountValid = selectedAccount => {
    return !!selfAccounts.find(account => parseInt(account.id) === selectedAccount)
  }

  const isPathSelfAccountValid = isAccountValid(selfAccountFromPath)

  if (isPathSelfAccountValid) {
    // path with correct selfAccount
    return selfAccountFromPath
  } else {
    // path with not correct selfAccount parameter - redirect to correct
    const savedAccount = getLocalStorage(SELECTED_SELF_ACCOUNT)
    const isSavedSelfAccountValid = savedAccount && isAccountValid(parseInt(savedAccount))
    const validAccountId = isSavedSelfAccountValid ? savedAccount : selfAccounts[0] && selfAccounts[0].id

    const isSelfAccountRelatedLink = checkIfSelfAccountRelatedLink(getCurrentRoute())
    if (isSelfAccountRelatedLink) {
      updateRouteParams({
        [ROUTE_PARAMS.selfAccount]: parseInt(validAccountId)
      })
    }

    return parseInt(validAccountId)
  }
}
